import React from 'react';
import { motion } from 'framer-motion';
const applications = [{
  sector: 'CLÍNICAS',
  flow: 'WhatsApp → IA → Calificación → Agenda → Seguimiento'
}, {
  sector: 'INMOBILIARIAS',
  flow: 'Consulta → Propiedad → Calificación → Visita → CRM'
}, {
  sector: 'SERVICIOS',
  flow: 'Solicitud → IA → Información → Cotización → Seguimiento'
}, {
  sector: 'EDUCACIÓN',
  flow: 'Interés → Programa → Calificación → Asesor → Matrícula'
}, {
  sector: 'E-COMMERCE',
  flow: 'Producto → Consulta → IA → Compra → Postventa'
}, {
  sector: 'EMPRESAS',
  flow: 'Lead → IA → CRM → Reunión → Seguimiento'
}];
export function Applications() {
  return <section className="bg-arena py-[56px] md:py-[88px]" data-id="element-53" data-mp="70m1hohm4oom">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-54" data-mp="c071m28ir32x">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="text-center mb-10" data-id="element-55" data-mp="bydwirdk0qx1">
          <h2 className="font-display text-[26px] md:text-[36px] font-bold text-carbon mb-2" data-id="element-56" data-mp="2y1b5vkhjbwgv">
            Una arquitectura. Diferentes empresas.
          </h2>
          <p className="font-body text-[13px] text-carbon/40 italic" data-id="element-57" data-mp="37q2yluuf6ksu">
            Escenarios de aplicación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-58" data-mp="32ykuwz10i646">
          {applications.map((app, idx) => <motion.div key={app.sector} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: idx * 0.04
        }} className="group bg-arena-dark border border-carbon/10 hover:border-verde/40 rounded-[12px] px-5 py-4 transition-colors duration-200" data-id="element-59" data-mp="3gp6gwwlriw6a" data-mpi={idx}>
              <span className="block font-body text-[12px] font-semibold uppercase tracking-[0.08em] text-carbon/70 mb-1.5" data-id="element-60" data-mp="1rc308ob8337p">
                {app.sector}
              </span>
              <span className="block font-body text-[13px] text-carbon/45 group-hover:text-verde transition-colors duration-200" data-id="element-61" data-mp="2h2becu8kxl1t">
                {app.flow}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}